import keccak256 from 'keccak256';
import { isHex } from 'viem';

function isHexList(list) {
  return list.every((value) => isHex(value));
}
function getSaltAsBytes32(salt) {
  return `0x${keccak256(salt.toString()).toString("hex")}`;
}
function getLazyOption(option) {
  return typeof option === "function" ? option() : option;
}
function scaleAmount({ amount, multiplier }) {
  return amount * BigInt(multiplier * 100) / 100n;
}
function parseTokenIdNumber(str) {
  const parsedInt = parseInt(str, 10);
  return isNaN(parsedInt) ? null : parsedInt;
}
function curry(fn) {
  const curried = (...args) => {
    if (args.length >= fn.length) {
      return fn(...args);
    }
    return curry((...args2) => fn(...args, ...args2));
  };
  return curried;
}
function exhaustiveGuard(_value) {
  throw new Error(`Exhaustive guard reached with value ${_value}`);
}
async function retry(fn, {
  attempts,
  delay
}) {
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn();
    } catch (error) {
      if (i < attempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      } else {
        throw error;
      }
    }
  }
  return fn();
}
function BigIntMin(...[firstValue, ...values]) {
  let value = firstValue;
  for (const currentValue of values) {
    if (currentValue < value)
      value = currentValue;
  }
  return value;
}
function BigIntMax(...[firstValue, ...values]) {
  let value = firstValue;
  for (const currentValue of values) {
    if (currentValue > value)
      value = currentValue;
  }
  return value;
}

export { BigIntMax, BigIntMin, curry, exhaustiveGuard, getLazyOption, getSaltAsBytes32, isHexList, parseTokenIdNumber, retry, scaleAmount };
